
        
      <app-type-rensA id="step12" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [adressesComplt]="initial.adressesComplt"></app-type-rensA>


